const Bedrooms = () => {
  return (
    <div>
      {/* HERO */}
      <div className="shell">
        <section className="hero" style={{ gridTemplateColumns: '1fr', paddingBottom: 40 }}>
          <div style={{ maxWidth: 900 }}>
            <span className="eyebrow">Sypialnie · 6 pokoi · 12 gości</span>
            <h1 className="display hero-headline" style={{ fontSize: 'clamp(48px, 6vw, 96px)' }}>
              Sześć pokoi,<br /><em>każdy inny</em>.
            </h1>
            <p className="hero-lede" style={{ maxWidth: 720 }}>
              Sześć sypialni na piętrze, ułożonych w trzy apartamenty —
              każdy z dwiema sypialniami i wspólną łazienką.
            </p>
          </div>
        </section>
      </div>

      {/* FLOOR PLAN */}
      <div className="shell">
        <section className="section" style={{ paddingTop: 20 }}>
          <div
            style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 48, alignItems: 'center' }}
            className="plan-block"
          >
            <img
              src="/photos/toskania-miejsca/plan.jpg"
              alt="Rzut piętra willi"
              style={{ width: '100%', aspectRatio: '16/11', objectFit: 'cover', display: 'block' }}
            />
            <div>
              <span className="eyebrow">Układ domu</span>
              <h2 className="display" style={{ fontSize: 40, margin: '10px 0 18px' }}>
                Dwa piętra,<br />wspólna przestrzeń.
              </h2>
              <p style={{ color: 'var(--ink-soft)', fontSize: 15, lineHeight: 1.65 }}>
                Na parterze: kuchnia, salon, pokój z kominkiem i jadalnia. Na piętrze — trzy apartamenty,
                każdy z dwiema sypialniami i łazienką. Na zewnątrz: kort tenisowy, basen z tarasem
                i widokiem na góry, winnica i dziedziniec.
              </p>
              <div
                style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginTop: 28 }}
              >
                {[
                  ['Łącznie', 'ponad 300 m²'],
                  ['Łazienek', '3 + WC'],
                  ['Maks. gości', '12'],
                  ['Teren', '1,7 ha'],
                ].map(([k, v]) => (
                  <div key={k} style={{ borderTop: '1px solid var(--line)', paddingTop: 10 }}>
                    <div className="small-caps olive">{k}</div>
                    <div className="display" style={{ fontSize: 22, marginTop: 4 }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Bedrooms;
